export default "__VITE_ASSET__2457c46c__"